import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Button, Dropdown, Menu, Modal, message } from 'antd'
import QueueAnim from 'rc-queue-anim'
import enquire from 'enquire.js'

import moment from 'moment'

import { DESKTOP_DOWN } from '../../config/mediaQueries'

import { generalActions } from './../../redux/actions'

import { integrationsService } from './../../redux/services'

import { UIAvatarLabel, UIPageListing } from './../../components'

import ModalShow from './show'
import ModalFilters from './filters'
import ModalEdit from './edit'
import ModalCreate from './create'
import ModalChangeIntegrationDate from './changeIntegrationDate';

const config = {
  title: 'Integrações',
  subtitle: 'Gerencie e acompanhe as integrações com o sistema de folha de pagamento.',
  icon: <i className="fal fa-plug" />,
  infoBanner: {
    icon: <i className="fal fa-info-circle" />,
    title: 'Sobre as integrações',
    description: 'As integrações permitem o envio de dados entre o sistema e a folha de pagamento. Mantenha as configurações atualizadas para garantir a comunicação correta.',
  },
  permissionPrefix: 'integracao',
  list: 'integrações',
  orders: [
    {
      label: 'Mais recentes',
      field: 'id',
      sort: 'desc',
      default: true,
    },
    {
      label: 'Mais antigos',
      field: 'id',
      sort: 'asc',
    },
  ],
}

class Index extends Component {
  constructor(props) {
    super(props)

    const defaultOrder = config.orders.find((o) => o.default)

    this.state = {
      isLoading: false,
      listType: 'list',
      data: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      orderByLabel: defaultOrder.label,
      orderByField: defaultOrder.field,
      orderBySort: defaultOrder.sort,
      // Actions
      createModalVisible: false,
      editModalVisible: false,
      filtersModalVisible: false,
      integrationDateModalVisible: false,
      showModalVisible: false,
      activeLoadings: [],
      // Media queries
      desktopDown: false,
      // Filters
      filters: {
        empresa: null,
        departamento: null,
        funcionario: null,
        justificativa: null,
      },
      kpis: null,
    }
  }

  static getDerivedStateFromProps(props, state) {
    if (props.listType && state.listType !== props.listType) {
      return {
        listType: props.listType,
      }
    }

    return null
  }

  componentDidMount() {
    // Fetch all
    this.fetchGetAll(true)

    // Listen Media Query sideBar
    enquire.register(DESKTOP_DOWN, {
      match: () => {
        this.setState({
          desktopDown: true,
        })
      },
      unmatch: () => {
        this.setState({
          desktopDown: false,
        })
      },
    })
  }

  componentWillUnmount() {
    // Unlisten Media Query sideBar
    enquire.unregister(DESKTOP_DOWN)
  }

  menuItem = (item) => (
    <Menu className="actions-dropdown-menu">
      {this.props.permissions.includes(config.permissionPrefix + ".show") &&
        <Menu.Item key="show">
          <a onClick={() => this.showOpen(item)}>
            <i className="fal fa-file" />
            Visualizar
          </a>
        </Menu.Item>
      }
      {this.props.permissions.includes(config.permissionPrefix + ".edit") &&
        <Menu.Item key="edit">
          <a onClick={() => this.editOpen(item)}>
            <i className="fal fa-pen" />
            Editar
          </a>
        </Menu.Item>
      }
      {this.props.permissions.includes(config.permissionPrefix + ".generate") &&
        <Menu.Item key="gerar">
          <a onClick={() => this.integrationDateOpen(item)}>
            <i className="far fa-check" />
            Gerar
          </a>
        </Menu.Item>
      }
      {this.props.permissions.includes(config.permissionPrefix + ".delete") &&
        <Menu.Item key="delete" className="divider btn-delete">
          <a onClick={() => this.deleteConfirm(item)}>
            <i className="fal fa-trash" />
            Excluir
          </a>
        </Menu.Item>
      }
    </Menu>
  )

  columns = () => {
    const listTypeCard = this.state.listType === 'card'
    return [
      {
        title: 'Descrição',
        render: (item) =>
          listTypeCard ? (
            <h3>{item.descricao || '-'}</h3>
          ) : (
            <UIAvatarLabel
              id={item.id}
              name={item.descricao || '-'}
              subtitle="Folha de Pagamento"
              icon={<i className="fal fa-plug" />}
              square
            />
          ),
      },
      {
        title: 'Empresa',
        render: (item) => listTypeCard ? <h3>{item.empresas.length ? item.empresas.map(empresa => empresa.nome).join(", ") : "Todas"}</h3> : item.empresas.length ? item.empresas.map(empresa => empresa.nome) : "Todas",
      },
      {
        title: 'Departamento',
        render: (item) =>
          listTypeCard ? <h3>{item.departamentos.length ? item.departamentos.map(departamento => departamento.nome).join(", ") : "Todos"}</h3> : item.departamentos.length ? item.departamentos.map(departamento => departamento.nome).join(", ") : "Todos",
      },
      {
        title: 'Funcionário',
        render: (item) => listTypeCard ? <h3>{item.funcionarios.length ? item.funcionarios.map(funcionario => funcionario.nome).join(", ") : "Todos"}</h3> : item.funcionarios.length ? item.funcionarios.map(funcionario => funcionario.nome).join(", ") : "Todos",
      },
      {
        title: 'Layout',
        render: (item) =>
          listTypeCard ? (
            <h3>{item.layout ?? '-'}</h3>
          ) : (
            item.layout ?? '-'
          ),
      },
      {
        title: 'Data do Cadastro',
        className: 'datetime',
        render: (item) => {
          if (listTypeCard) {
            return (
              <Fragment>
                <i className="fal fa-plus-circle" style={{ marginRight: 5 }} />
                {moment(item.created_at).format('DD/MM/YYYY')}
              </Fragment>
            )
          }

          return moment(item.created_at).format('DD/MM/YYYY')
        },
      },
      {
        title: 'Ações',
        className: 'actions no-ellipsis',
        visible: this.props.permissions.includes(config.permissionPrefix + ".show") || this.props.permissions.includes(config.permissionPrefix + ".edit") || this.props.permissions.includes(config.permissionPrefix + ".delete") || this.props.permissions.includes(config.permissionPrefix + ".generate"),
        render: (item) => (
          <Dropdown
            overlay={this.menuItem(item)}
            className="actions-dropdown"
            placement="bottomRight"
            trigger={['click']}
          >
            <Button icon={<i className="fal fa-ellipsis-v" />} />
          </Dropdown>
        ),
      },
    ]
  }

  fetchGetAll = (init = false) => {
    const { pagination, orderByField, orderBySort, filters } =
      this.state

    this.setState({
      isLoading: true,
    })

    const data = {
      orderBy: `${orderByField}:${orderBySort}`,
    }

    data.page = init ? 1 : pagination.current
    data.limit = pagination.pageSize

    if (filters.empresa !== null) {
      data.empresa = filters.empresa;
    }

    if (filters.departamento !== null) {
      data.departamento = filters.departamento;
    }

    if (filters.funcionario !== null) {
      data.funcionario = filters.funcionario;
    }

    integrationsService
      .getAll(data)
      .then((response) => {
        this.setState((state) => ({
          isLoading: false,
          data: response.data.data,
          kpis: response.data.kpis ?? null,
          pagination: {
            ...state.pagination,
            current: response.data.meta.current_page,
            total: response.data.meta.total,
          },
        }))
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  onListTypeChange = (type) => {
    this.props.onChangeListType(type)
  }

  onPaginationChange = (page, pageSize) => {
    this.setState(
      (state) => ({
        pagination: {
          ...state.pagination,
          current: page,
          pageSize,
        },
      }),
      () => {
        this.fetchGetAll()
      }
    )
  }

  onOrderChange = (value) => {
    const defaultOrder = config.orders.find(
      (o) => `${o.field}:${o.sort}` === value
    )

    if (!defaultOrder) return null

    this.setState(
      (state) => ({
        orderByLabel: defaultOrder.label,
        orderByField: defaultOrder.field,
        orderBySort: defaultOrder.sort,
      }),
      () => {
        this.fetchGetAll(true)
      }
    )
  }

  /**
   * Show
   *
   * @param uuid
   */
  showOpen = ({ uuid }, general_key) => {
    this.setState({ showModalVisible: true })

    // On open screen
    this.showScreen.onOpen(uuid, general_key)
  }

  showOnClose = () => {
    this.setState({ showModalVisible: false })
  }

  showOnEdit = (uuid) => {
    this.showOnClose()
    this.editOpen({ uuid })
  }

  /**
   * Delete
   *
   * @param uuid
   */
  deleteConfirm = ({ uuid }) => {
    Modal.confirm({
      title: 'Confirmar exclusão!',
      content: 'Tem certeza de que deseja excluir este registro?',
      okText: 'Excluir',
      autoFocusButton: null,
      onOk: () => {
        return this.deleteConfirmed(uuid)
      },
    })
  }

  deleteConfirmed = (uuid) => {
    return integrationsService
      .destroy({ uuid })
      .then((response) => {
        // Fetch all
        this.fetchGetAll()
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  /**
    * Create
    */
  createOpen = () => {
    this.setState({ createModalVisible: true });

    // On open screen
    this.createScreen.onOpen();
  };

  createOnClose = () => {
    this.setState({ createModalVisible: false });
  };

  createOnComplete = () => {
    this.setState({ createModalVisible: false });
    // Fetch all
    this.fetchGetAll(true)
  };

  /**
   * Edit
   *
   * @param uuid
   */
  editOpen = ({ uuid }) => {
    this.setState({ editModalVisible: true })

    // On open screen
    this.editScreen.onOpen(uuid)
  }

  editOnClose = () => {
    this.setState({ editModalVisible: false })
  }

  editOnComplete = () => {
    this.setState({ editModalVisible: false })

    // Fetch all
    this.fetchGetAll()
  }

  /**
   * Filter
   */
  filtersOpen = () => {
    this.setState({ filtersModalVisible: true })

    // On open screen
    this.filtersScreen.onOpen({ ...this.state.filters })
  }

  filtersOnClose = () => {
    this.setState({ filtersModalVisible: false })
  }

  filtersOnComplete = (filters) => {
    this.setState({ filtersModalVisible: false })
    this.setState(
      {
        filters: filters,
      },
      () => {
        // Fetch all
        this.fetchGetAll(true)
      }
    )
  }

  integrationDateOpen = (item) => {
    this.setState({ integrationDateModalVisible: true })

    // On open screen
    this.integrationDateScreen.onOpen(item);
  }

  integrationDateOnClose = () => {
    this.setState({ integrationDateModalVisible: false })
  }

  integrationDateOnComplete = (item) => {
    this.setState({ integrationDateModalVisible: false })
    const empresas_ids = item.empresas.map(empresa => empresa.id);
    const departamentos_ids = item.departamentos.map(departamento => departamento.id);
    const funcionario_ids = item.funcionarios.map(funcionario => funcionario.id);

    integrationsService
      .edit({
        ...item,
        empresas: empresas_ids,
        departamentos: departamentos_ids,
        funcionarios: funcionario_ids,
      })
      .then((response) => {
        this.setState({
          isSending: false,
        })

        // Callback
        this.handleGenerateTxtFile(item)
      })
      .catch((data) => {
        this.setState({
          isSending: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  handleGenerateTxtFile = (item) => {
    this.setState({
      isLoading: true
    });

    const hideMessage = message.loading('Processando dados...', 0);
    return integrationsService
      .integrationFile(item)
      .then((response) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'export_layout_dominio.txt');
        link.target = '_blank';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Exibe mensagem de sucesso
        message.success('Arquivo gerado com sucesso');
      })
      .catch((data) => {
        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        });
      })
      .finally(() => {
        hideMessage();
        this.setState({
          isLoading: false
        });
      });
  };

  render() {
    return (
      <QueueAnim className="site-content-inner">
        <div className="page-content fixed-header" key="1">
          <UIPageListing
            icon={config.icon}
            title={config.title}
            subtitle={config.subtitle}
            kpis={[
              {
                key: 'total',
                tone: 'blue',
                icon: <i className="fal fa-plug" />,
                title: 'Total de integrações',
                value: this.state.kpis?.total ?? '—',
                caption: 'Cadastradas no sistema',
              },
            ]}
            infoBanner={config.infoBanner}
            enableSearch={false}
            onPaginationChange={this.onPaginationChange}
            onOrderChange={this.onOrderChange}
            onListTypeChange={this.onListTypeChange}
            onFiltersClick={this.filtersOpen}
            isLoading={this.state.isLoading}
            listType={this.state.listType}
            orderByField={this.state.orderByField}
            orderBySort={this.state.orderBySort}
            orders={config.orders}
            data={this.state.data}
            pagination={this.state.pagination}
            columns={this.columns()}
            showFilters={true}
            buttons={[
              {
                visible: this.props.permissions.includes(config.permissionPrefix + ".create"),
                onClick: this.createOpen,
                title: 'Incluir',
                icon: <i className="far fa-plus" />,
              },
            ]}
          />
        </div>
        <ModalCreate
          ref={el => this.createScreen = el}
          visible={this.state.createModalVisible}
          onComplete={this.createOnComplete}
          onClose={this.createOnClose}
        />
        <ModalEdit
          ref={(el) => (this.editScreen = el)}
          visible={this.state.editModalVisible}
          onComplete={this.editOnComplete}
          onClose={this.editOnClose}
        />
        <ModalShow
          ref={(el) => (this.showScreen = el)}
          visible={this.state.showModalVisible}
          onClose={this.showOnClose}
          onEdit={this.props.permissions.includes(config.permissionPrefix + ".edit") ? this.showOnEdit : undefined}
        />
        <ModalFilters
          ref={(el) => (this.filtersScreen = el)}
          visible={this.state.filtersModalVisible}
          onComplete={this.filtersOnComplete}
          onClose={this.filtersOnClose}
        />
        <ModalChangeIntegrationDate
          ref={(el) => (this.integrationDateScreen = el)}
          visible={this.state.integrationDateModalVisible}
          onComplete={this.integrationDateOnComplete}
          onClose={this.integrationDateOnClose}
        />
      </QueueAnim>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    permissions: state.auth.userData.permissions,
    listType: state.general.listType[config.list],
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onChangeListType: (type) => {
      dispatch(generalActions.changeListType(config.list, type))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
